import * as core from '../../../../../../../core'

import { query } from './stakeholders-by-engagement-level.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.by.engagement.level',
    description: 'Chart view of stakeholders by engagement level',
    name: 'Stakeholders by Engagement Level',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
